import { render, staticRenderFns } from "./VehicleIncomeRatioBarChart.vue?vue&type=template&id=3d9d6f7b&"
import script from "./VehicleIncomeRatioBarChart.vue?vue&type=script&lang=js&"
export * from "./VehicleIncomeRatioBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports